import { SettingsInjections } from 'generics/settingsInjections';
import localforage from "localforage";

export class DatCache  {
  constructor({ name, timeoutSec, timeoutMin, timeoutHrs,  splitPending })  {
    this.name = name;
    this.db = localforage.createInstance({  name  });
    let tsec = (timeoutSec||0);
    tsec += (timeoutMin||0)*60;
    tsec += (timeoutHrs||0)*3600;
    tsec = tsec > 0 ? tsec : (10*60);
    this.timeoutMs = tsec*1000;
    this.splitPending = splitPending;

    this.pending = {};
  }


  hash(req)  {
    return req.map( it => `${it}` ).join("\n");
  }


  resolve(...req)  {
    const prefix = SettingsInjections.getUsedCircuitName();
    const key = `${prefix}${this.hash(req)}`;
    const stamp = Date.now();
    const exp = stamp - this.timeoutMs;
    if ( (!this.splitPending) && this.pending[key] )
      return this.pending[key];

    this.pending[key] = this.db.getItem( key ).then( (item)  =>  {
        if (item)  {
          if (!item.stamp)
            return item.result;
          if (item.stamp > exp)
            return item.result;
        }

        return this.fetch(key, req).then( (result)  =>  {
          return this.db.setItem(
              key,  {key, stamp, result}
            ).then( (item) => {
                return item.result;
            });
        });
      });
    this.pending[key].then(
        () => {delete this.pending[key]},
        () => {delete this.pending[key]}
      );
    return this.pending[key];
  }


  fetch(key, req)  {
    throw new Error("must override fetch for cache", this.name);
  }
}
